import React from 'react';
import { Container } from 'reactstrap';
import PersonalProtectiveEquipmentList from './PersonalProtectiveEquipmentList';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import UiContent from '../../Components/Common/UiContent';
import { icon } from 'leaflet';


//redux

const PersonalProtectiveEquipment = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Abastecimiento', icon: 'icon-shopping-basket' },
		{ to: '#', label: 'Gestión de EPP', icon: 'icon-shirt' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Asignaciones' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<PersonalProtectiveEquipmentList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PersonalProtectiveEquipment;
